import { DESTINATION_TYPE } from '@adtrackify/at-tracking-event-types';

export function checkIntegrationConnections(destinations: Array<{ destination?: string; destinationType?: string; enabled?: boolean } | undefined>) {
  const isShopifyConnected = destinations.some(
    (d) =>
      d?.destination === 'shopifyIntegration' &&
      d?.destinationType === DESTINATION_TYPE.INTEGRATION &&
      d?.enabled
  );

  const isFacebookAdsConnected = destinations.some(
    (d) =>
      d?.destination === 'facebookIntegration' &&
      d?.destinationType === DESTINATION_TYPE.INTEGRATION &&
      d?.enabled
  );

  const isGoogleAdsConnected = destinations.some(
    (d) =>
      d?.destination === 'googleAdsIntegration' &&
      d?.destinationType === DESTINATION_TYPE.INTEGRATION &&
      d?.enabled
  );

  const isTiktokAdsConnected = destinations.some(
    (d) =>
      d?.destination === 'tiktokIntegration' &&
      d?.destinationType === DESTINATION_TYPE.INTEGRATION &&
      d?.enabled
  );

  return {
    isShopifyConnected,
    isFacebookAdsConnected,
    isGoogleAdsConnected,
    isTiktokAdsConnected,
    anyDataSourceConnected: isFacebookAdsConnected || isGoogleAdsConnected || isTiktokAdsConnected,
  };
}
